<template>
  <div>
    <van-cell-group class="body kuang">
      <van-cell v-if="list.school" title="学校" :value="list.school" />
       <van-cell
        v-if="list.province"
        title="地区"
        :value="`${list.province || ''}${list.city || ''}${list.district || ''}`"
      />
      <van-cell
        v-if="list.train"
        title="本年度是否参加过培训"
        :value="format(list.train, 1)"
      />
      <template v-if="list.train == 1">
        <div v-for="(item, index) in list.items" :key="index" class="cnt">
          <van-cell-group>
            <van-cell v-if="item.trainName" title="培训名称" :value="item.trainName" />
            <van-cell
              v-if="item.trainLevel"
              title="培训级别"
              :value="format(item.trainLevel, 15)"
            />
            <van-cell
              v-if="item.organizer"
              title="主办单位"
              :value="format(item.organizer, 16)"
            />
            <van-cell v-if="item.classHours" title="学时" :value="item.classHours" />
            <van-cell
              v-if="item.trainDate"
              title="培训日期"
              :value="format(item.trainDate, 6)"
            />
          </van-cell-group>
        </div>
      </template>
    </van-cell-group>
  </div>
</template>
<script>
import { format } from "@/common/js/utils";
export default {
  props: {
    list: Object,
  },
  setup() {
    return { format };
  },
};
</script>
<style lang="less" scoped>
.body {
  margin-bottom: 1.53333rem;
}
.cnt {
  border-bottom: 4px solid #f9f9f9;
}
</style>
